import reqwest from 'reqwest'

const dfttUrl = 'https://www.toutiaoyule.com/newspool/2345/newssidebar.php';
const newsFilterRules = 'http://newsie.2345.cc/api/config.json';
const dfttCount = 'http://2345jsllqlog.dftoutiao.com/newslog_pc/click';
export default {
    postData : {
        // type    : '',
        // startkey: '',
        // newkey  : '',
        // pgnum   : '1',
        // uid     : 'donguuuutest2',
        // idx     : '0',
				// qid     : '2345jsllq',
				type: '',
				page: 1,
    },
    setParm(data){
				let params = this.postData;
				params.type = data.type
				params.page = data.page
        // params.type = data.type;
        // params.startkey = data.startkey;
        // params.newkey = data.newkey;
        // params.pgnum = data.pgnum;
        // params.idx = data.idx;
        // params.uid = data.uid;
        // if(!params.startkey && !params.newkey){
        //     params.pgnum = 1;
        // }
    },
    getNewsList (callback) {
        reqwest({
            url: dfttUrl,
						data: this.postData,
            type: 'jsonp',
            jsonpCallback: 'callback',
            timeout: 5000
        })
        .then(val => callback(null, val))
        .catch(e => callback(e))
    },
    getFilterRule(params, callback) {
        reqwest({
            url: newsFilterRules,
            data: params,
            type: 'jsonp',
            jsonp: 'callBack'
        })
        .then(val => callback(null, val))
        .catch(e => callback(e))
    },
    sendToDftt(params, callback){
        reqwest({
            url: dfttCount,
            data: params,
            type: 'jsonp',
            jsonpCallback: 'callback'
        })
        .then(val => callback(null, val))
        .catch(e => callback(e))
    }
}
